
<script>
import NewForm from './New'
export default {
  mixins: [NewForm],
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.$http.get(`record-units/${this.$route.query.id}`).then(res => {
        this.form = { ...res.data, name: res.data.locales.ja_JP }
      })
    },
    save() {
      this.$http
        .put(`record-units/${this.$route.query.id}`, this.form)
        .then(() => {
          this.$router.go(-1)
        })
    },
    remove() {
      this.$confirm({ content: this.$t('app.messages.removeConfirm') }).then(
        () => {
          this.$http
            .delete(`/record-units/${this.$route.query.id}`)
            .then(() => {
              this.$router.go(-1)
              this.$message('', '削除成功')
            })
        }
      )
    }
  }
}
</script>
